import { Injectable } from '@angular/core';
import {CHAT_CONSTANTS} from '../utils/app.constants';

const mockResponses = `
<<notification>>To assist you with your request, I will gather the detailed information for booking ID 224343 and also retrieve the conversation history related to this booking. This will help ensure that I have all the relevant details and context to address your needs effectively.<</notification>>
---CHUNK---
<<notification>>I have gathered the detailed information for booking ID 224343, including the booking status, guest details, hotel information, pricing, and cancellation policy. Next, I will review the conversation history related to this booking to provide you with a complete overview of all previous interactions and updates associated with it. This will help ensure you have a comprehensive understanding of the booking's background and any actions taken so far.<</notification>>
---CHUNK---

Here are the details for booking ID 224343, along with the conversation history so far:

---

### 🏨 Booking Details for ID 224343

- **Status:** Confirmed
- **Client Reference:** Tra007
- **Company:** Desert Adventures (DA_UAE)
- **Division:** FIT UAE
- **Brand:** FIT- WW
- **Booking Type:** Standard
- **Distribution Channel:** B2B
- **Source Market:** AE (United Arab Emirates)
- **Selling Currency:** AED
- **Booking Date:** 2025-08-27
- **Lead Name:** Mr test test
- **Booked User:** madutest madutest

#### 🗓️ Stay Information
- **Hotel:** @@action|Jumeirah Beach Hotel|Jumeirah Beach Hotel|HOTEL@@  in  @@action|Dubai|Dubai|CITY@@
- **Product Code:** HTL~1
- **Room:** 1 Ocean Deluxe Room, Room Only
- **Guests:** 2 adults
- **Nights:** 4 (2025-08-29 to 2025-09-02)
- **Total Price:** 15,268.4 AED (including 727.07 AED tax)
- **Balance Due:** 15,268.4 AED

#### 🏷️ Inclusions & Policies
- **Status:** Confirmed
- **Complimentary:** Wi-Fi and access to @@action|Wild Wadi waterpark|Wild Wadi waterpark|POI@@
- **Cancellation Policy:**
  - Free cancellation until 2025-08-27 00:00 (GMTZ)
  - After that, 7,634.2 AED fee applies
  - No-show or post check-in changes may incur up to 100% penalty
- **Taxes Included:** Service Charge, VAT, Municipality Fee
- **Supplier:** Jumeirah Beach Hotel NEW VALUE 04 (JUM001)
- **Check-in Instructions:** Provided (including special requirements)

---

### 💬 Conversation History

There are currently **no recorded conversation or history entries** for booking ID 224343.

---

If you need more details about this booking, the hotel, or want to explore nearby attractions, just let me know!



<CHAT_VIEW><COMPONENT>{"component_type": "PromptSuggestionList", "content": {"headingSuggestions": [{"heading": "", "suggestions": [{"message": "View booking 224343", "payload": {"opCode": "BKG_VIEW", "attributes": [{"name": "bkgId", "value": "224343"}]}}, {"message": "", "payload": {"opCode": "AGENT_PERFORM", "attributes": {"agentName": "LeadAgentV2.2", "query": "Show me the details of booking id 224343", "session_id": "ea319606-d77d-4ecb-b354-365445c612cc", "duration": "68.781822", "planningTime": "68.438902", "toolExecutionTime": "0.34292", "usedTools": [{"toolName": "booking_details_tool", "executionData": [{"occurrence": "1", "duration": "0.299756", "args": {}, "kwargs": {"booking_id": "224343"}, "status": "success"}]}, {"toolName": "booking_history_tool", "executionData": [{"occurrence": "1", "duration": "0.043164", "args": {}, "kwargs": {"booking_id": "224343"}, "status": "success"}, {"occurrence": "2", "duration": "0.043164", "args": {}, "kwargs": {"booking_id": "224343"}, "status": "success"}]}]}}}]}, {"heading": "What would you like to know next?", "suggestions": [{"message": "Show cancellation policy for this booking", "payload": {}}, {"message": "Show payment and balance details", "payload": {}}, {"message": "Show hotel details for Jumeirah Beach Hotel", "payload": {}}]}]}}</COMPONENT></CHAT_VIEW>
`;

@Injectable({
  providedIn: 'root'
})
export class MockAgentService {
  private responseChunks: string[] = mockResponses.split('---CHUNK---').map(c => c.trim());

  fetch(url: string, options: any): Promise<any> {
    const encoder = new TextEncoder();
    let chunkIndex = 0;

    const stream = new ReadableStream({
      pull: async (controller) => {
        if (chunkIndex < this.responseChunks.length) {
          controller.enqueue(encoder.encode(this.responseChunks[chunkIndex]));
          chunkIndex++;
          await new Promise(resolve => setTimeout(resolve, CHAT_CONSTANTS.TIMERS.MOCK_STREAM_DELAY)); // simulate delay
        } else {
          controller.close();
        }
      }
    });

    return Promise.resolve({
      body: stream,
      ok: true
    });
  }
}
